import { useQuery } from "@tanstack/react-query";

import { useAuthHeaders } from "../auth/apiClient";

export interface RiskQueueItem {
  id?: string;
  source?: "email" | "sms" | "call_task" | "reminder";
  source_id?: string | null;
  priority: "Critical" | "High" | "Watch";
  quote_id: string;
  customer_name: string;
  ghosted?: boolean;
  location: string;
  value: number;
  status: string;
  reply_category: string | null;
  reply_confidence: number | null;
  last_activity_at?: string | null;
  excerpt?: string | null;
  next_action: string;
  murray_focus?: {
    id: string;
    title: string;
    action: string | null;
    target_metric: string | null;
  } | null;
}

export function useRiskQueue(enabled = true) {
  const headers = useAuthHeaders();
  return useQuery({
    queryKey: ["control-tower", "quotes", "risk-queue"],
    queryFn: async () => {
      const res = await fetch("/api/cockpit/quotes/risk-queue", { headers });
      if (!res.ok) throw new Error(`Risk queue failed: ${res.status}`);
      return res.json() as Promise<{ items: RiskQueueItem[] }>;
    },
    enabled,
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
